/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { AppUserRole } from "./app-user-role";

export class AppRole {
    id: number;
    name: string;
    description: string;
    appUserRoles: AppUserRole[];
}
